import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';

export interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  labelPosition?: 'left' | 'right';
  error?: string;
}

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(
  ({ label, labelPosition = 'right', error, className = '', ...props }, ref) => {
    return (
      <label className="inline-flex items-center gap-3 cursor-pointer group">
        {label && labelPosition === 'left' && (
          <span className="text-sm font-medium text-gray-700 dark:text-gray-300 select-none">
            {label}
          </span>
        )}
        <div className="relative">
          <input
            ref={ref}
            type="checkbox"
            className="sr-only peer"
            {...props}
          />
          <div
            className={`w-11 h-6 bg-gray-200 dark:bg-gray-700 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-500 rounded-full peer-checked:bg-blue-600 dark:peer-checked:bg-blue-500 transition-colors duration-200 ${
              error ? 'peer-focus:ring-red-500' : ''
            } ${className}`}
          >
            <div className="absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow-sm transition-transform duration-200 peer-checked:translate-x-5" />
          </div>
        </div>
        {label && labelPosition === 'right' && (
          <span className="text-sm font-medium text-gray-700 dark:text-gray-300 select-none">
            {label}
          </span>
        )}
      </label>
    );
  }
);

Switch.displayName = 'Switch';

export default Switch;
